import { VM } from '../../../core/VM';
import { Desktop } from './Desktop';
import { Mobile } from './Mobile';
let view = VM();
export const Index = () => {
  return view === '' ? <Desktop/> : <Mobile/>
}